import { CalendarDays, Settings, ShoppingCart, Users } from "lucide-react";
import { productFeatures } from "@/lib/product-features";

type DashboardNavPath =
  | "/dashboard/calendar"
  | "/dashboard/pos"
  | "/dashboard/clients"
  | "/dashboard/settings";

type DashboardSection = "calendar" | "pos" | "clients" | "settings";

interface DashboardNavItem {
  to: DashboardNavPath;
  section: DashboardSection;
  icon: typeof CalendarDays;
  label: string;
  ownerOnly?: boolean;
}

const DASHBOARD_NAV_ITEMS: DashboardNavItem[] = [
  { to: "/dashboard/calendar", section: "calendar", icon: CalendarDays, label: "Calendar" },
  { to: "/dashboard/pos", section: "pos", icon: ShoppingCart, label: "Sales" },
  { to: "/dashboard/clients", section: "clients", icon: Users, label: "Clients" },
  {
    to: "/dashboard/settings",
    section: "settings",
    icon: Settings,
    label: "Settings",
    ownerOnly: true,
  },
];

export function dashboardNavItemsForRole(role: string | undefined): DashboardNavItem[] {
  return DASHBOARD_NAV_ITEMS.filter(
    (item) =>
      (item.section !== "pos" || productFeatures.sales) && (!item.ownerOnly || role === "owner"),
  );
}

export function canAccessDashboardSettings(role: string | undefined): boolean {
  return role === "owner";
}

export type { DashboardNavItem, DashboardNavPath };
